module.exports = __webpack_public_path__ + "4156dc3f9af412ea0e9014d2b4d5e9c5.png";